// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4241e30d","498":"be63b2b1","703":"05617f9c","787":"0f8d78ff"}[chunkId] + ".chunk.js";
};